var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnPencilBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.05125 2.89746H2.78917C2.31465 2.89746 1.85957 3.08596 1.52403 3.4215C1.1885 3.75703 1 4.21211 1 4.68663V17.2108C1 17.6853 1.1885 18.1404 1.52403 18.4759C1.85957 18.8115 2.31465 19 2.78917 19H15.3133C15.7879 19 16.2429 18.8115 16.5785 18.4759C16.914 18.1404 17.1025 17.6853 17.1025 17.2108V10.9487",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7606 1.55582C16.1164 1.19994 16.5991 1 17.1024 1C17.6057 1 18.0884 1.19994 18.4443 1.55582C18.8002 1.91171 19.0001 2.3944 19.0001 2.8977C19.0001 3.401 18.8002 3.88369 18.4443 4.23957L9.94577 12.7381L6.36743 13.6327L7.26202 10.0544L15.7606 1.55582Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPencilBox);
export default __webpack_public_path__ + "static/media/icn-pencil-box.692160c550532659c38c9a74b88e724f.svg";
export { ForwardRef as ReactComponent };